import { fromBlobToFileUpload } from '~/components/text-editor/utils';

export default class InsertDocumentController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 */
	constructor(
		$injector,
		$timeout,
		$uibModalInstance,
	) {
		this.$injector = $injector;
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;

		this.file = null;
		this.isDrawing = false;
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {any[]} file
	 */
	onDrop(file) {
		this.$timeout(() => {
			this.file = Array.isArray(file) ? file[0] : file;
		});
	}

	/**
	 * @param {boolean} isDrawing
	 */
	toggleDraw(isDrawing) {
		this.isDrawing = isDrawing;
	}

	deleteFile() {
		this.file = null;
	}

	/**
	 * @param {HTMLCanvasElement} canvas
	 */
	// eslint-disable-next-line class-methods-use-this
	onSaveDrawing(canvas) {
		canvas.toBlob(blob => blob ? this.insert(new File([blob], 'drawing')) : null);
	}

	/**
	 * @param {?File} file
	 * @returns {Promise<void>}
	 */
	async insert(file = null) {
		try {
			const fileUpload = await fromBlobToFileUpload(this.$injector, file ?? this.file, 'K_NODE;DOCUMENT');
			return this.$uibModalInstance.close(fileUpload);
		}
		catch (error) {
			console.error('e', error);
		}
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}
}
